var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("form-button-disabler", [
    _c(
      "div",
      { staticClass: "grid grid-cols-2 gap-x-4" },
      [
        _c(
          "field",
          {
            staticClass: "pb-2",
            attrs: {
              label: "Status",
              "error-text": _vm.showValidations ? _vm.validations.status : "",
            },
          },
          [
            _c("text-field", {
              attrs: { disabled: "" },
              model: {
                value: _vm.model.status,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "status", $$v)
                },
                expression: "model.status",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          {
            staticClass: "pb-2",
            attrs: {
              label: "Bid Due Date",
              "error-text": _vm.showValidations ? _vm.bidDueDateValidation : "",
            },
          },
          [
            _c("date-field", {
              attrs: { format: "MM/dd/yyyy hh:mm a" },
              model: {
                value: _vm.model.packageBuyInfo.bidDueDate,
                callback: function ($$v) {
                  _vm.$set(_vm.model.packageBuyInfo, "bidDueDate", $$v)
                },
                expression: "model.packageBuyInfo.bidDueDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          {
            staticClass: "pb-2",
            attrs: {
              label: "Package Name",
              "error-text": _vm.showValidations ? _vm.validations.name : "",
              disabled: _vm.packageNameDisabled,
            },
          },
          [
            _c("text-field", {
              attrs: {
                disabled: _vm.packageNameDisabled,
                placeholder: "Seller's Moniker MMDDYYY",
              },
              on: {
                input: function ($event) {
                  return _vm.onPackageNameInput()
                },
              },
              model: {
                value: _vm.model.name,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "name", $$v)
                },
                expression: "model.name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "field",
          {
            staticClass: "pb-2",
            attrs: {
              label: "Bid Request Date",
              "error-text": _vm.showValidations
                ? _vm.bidRequestDateValidation
                : "",
            },
          },
          [
            _c("date-field", {
              model: {
                value: _vm.model.packageBuyInfo.bidRequestDate,
                callback: function ($$v) {
                  _vm.$set(_vm.model.packageBuyInfo, "bidRequestDate", $$v)
                },
                expression: "model.packageBuyInfo.bidRequestDate",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("asset-class-dropdown-field", {
          staticClass: "pb-2",
          attrs: {
            "auto-assign": "",
            "error-text": _vm.showValidations ? _vm.assetClassValidation : "",
          },
          model: {
            value: _vm.model.assetClass.id,
            callback: function ($$v) {
              _vm.$set(_vm.model.assetClass, "id", $$v)
            },
            expression: "model.assetClass.id",
          },
        }),
        _vm._v(" "),
        _c("balance-type-dropdown-field", {
          staticClass: "pb-2",
          attrs: {
            "auto-assign": "",
            "error-text": _vm.showValidations ? _vm.balanceTypeValidation : "",
          },
          model: {
            value: _vm.model.packageBuyInfo.balanceType.id,
            callback: function ($$v) {
              _vm.$set(_vm.model.packageBuyInfo.balanceType, "id", $$v)
            },
            expression: "model.packageBuyInfo.balanceType.id",
          },
        }),
        _vm._v(" "),
        _c("country-dropdown-field", {
          staticClass: "pb-2",
          attrs: {
            "auto-assign": "",
            "error-text": _vm.showValidations ? _vm.countryValidation : "",
          },
          model: {
            value: _vm.model.country.id,
            callback: function ($$v) {
              _vm.$set(_vm.model.country, "id", $$v)
            },
            expression: "model.country.id",
          },
        }),
        _vm._v(" "),
        _c("currency-dropdown-field", {
          staticClass: "pb-2",
          attrs: {
            "auto-assign": "",
            "error-text": _vm.showValidations ? _vm.currencyValidation : "",
          },
          model: {
            value: _vm.model.currency.id,
            callback: function ($$v) {
              _vm.$set(_vm.model.currency, "id", $$v)
            },
            expression: "model.currency.id",
          },
        }),
        _vm._v(" "),
        _c("task-template-dropdown-field", {
          staticClass: "pb-2",
          attrs: { label: "Template", placeholder: "Select Task Template" },
          model: {
            value: _vm.model.taskTypeTemplateId,
            callback: function ($$v) {
              _vm.$set(_vm.model, "taskTypeTemplateId", $$v)
            },
            expression: "model.taskTypeTemplateId",
          },
        }),
        _vm._v(" "),
        _c(
          "field",
          {
            staticClass: "pb-2 strip-type-field col-span-1",
            attrs: {
              label: "Strip Type",
              "error-text": _vm.showValidations
                ? _vm.includeLoanRightsValidation
                : "",
            },
          },
          [
            _c("checkbox", {
              attrs: { label: "Whole Loan" },
              model: {
                value: _vm.includeWholeLoanRights,
                callback: function ($$v) {
                  _vm.includeWholeLoanRights = $$v
                },
                expression: "includeWholeLoanRights",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "strip-types-divider" }),
            _vm._v(" "),
            _c("checkbox", {
              attrs: {
                disabled: _vm.includeWholeLoanRights,
                label: "Loan w/o Servicing Rights (Retained by Seller)",
              },
              model: {
                value: _vm.model.packageBuyInfo.includeLoanRights,
                callback: function ($$v) {
                  _vm.$set(_vm.model.packageBuyInfo, "includeLoanRights", $$v)
                },
                expression: "model.packageBuyInfo.includeLoanRights",
              },
            }),
            _vm._v(" "),
            _c("checkbox", {
              attrs: {
                disabled: _vm.includeWholeLoanRights,
                label: "Servicing Rights",
              },
              model: {
                value: _vm.model.packageBuyInfo.includeServicingRights,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.model.packageBuyInfo,
                    "includeServicingRights",
                    $$v
                  )
                },
                expression: "model.packageBuyInfo.includeServicingRights",
              },
            }),
            _vm._v(" "),
            _c("checkbox", {
              staticClass: "pb-2",
              attrs: {
                disabled: _vm.includeWholeLoanRights,
                label: "Prepayment Penalty",
              },
              model: {
                value: _vm.model.packageBuyInfo.includePPPRights,
                callback: function ($$v) {
                  _vm.$set(_vm.model.packageBuyInfo, "includePPPRights", $$v)
                },
                expression: "model.packageBuyInfo.includePPPRights",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex" },
      [
        _c("div", { staticClass: "flex-grow" }),
        _vm._v(" "),
        _c(
          "btn",
          {
            on: {
              click: function ($event) {
                return _vm.closeProp()
              },
            },
          },
          [_vm._v("Add Package")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }